var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"mr-3 btn white big",attrs:{"type":"button","disabled":_vm.campaignPartialSaveLoading},on:{"click":_vm.saveFormData}},[_vm._v("Save ")])
}
var staticRenderFns = []

export { render, staticRenderFns }